import Stack from "@mui/material/Stack";
import { useContext } from "react";
import * as yup from "yup";
import { Form, FormContext } from "components/shared/Form";
import { buildGenericModelForm } from "components/shared/GenericModelForm";
import FormButtons from "components/ui/atoms/FormButtons";
import ListSelectField from "components/ui/atoms/formFields/ListSelectField";
import RHFTextField from "components/ui/atoms/formFields/RHFTextField";
import TagField from "components/ui/atoms/formFields/TagField";
import PeopleFormHeader from "models/people/PeopleFormHeader";
import {
  useCreatePeople,
  useDeletePeople,
  usePeople,
  useUpdatePeople,
} from "models/people/apiPeople";

const updateValidationSchema = yup.object({
  main_email_address: yup.string().email().nullable(),
  main_name: yup.string().nullable(),
  main_phone_number: yup.string().nullable(),
  description: yup.string().nullable(),
  tags_sectors: yup.array().nullable(),
  tags_business_models: yup.array().nullable(),
});

const createValidationSchema = yup.object({
  main_email_address: yup.string().email().required(),
  main_name: yup.string().nullable(),
  main_phone_number: yup.string().nullable(),
  description: yup.string().nullable(),
  tags_sectors: yup.array().nullable(),
  tags_business_models: yup.array().nullable(),
});

export const getInitialValues = (object) => {
  return {
    main_email_address: object?.best_email_address || "",
    main_name: object?.best_name || "",
    main_phone_number: object?.main_phone_number || "",
    description: object?.description || "",
    tags_sectors: (object?.tags_sectors || []).sort(),
    tags_business_models: (object?.tags_business_models || []).sort(),
  };
};

export const PeopleFormFields = () => {
  const { onCancel, formType, object: people } = useContext(FormContext);

  return (
    <>
      <PeopleFormHeader
        formType={formType}
        onClose={onCancel}
        people={people}
      />
      <Stack spacing={2} padding={2}>
        <RHFTextField name="main_name" label="Principal name" fullWidth />
        <ListSelectField
          options={people?.email_addresses.map((x) => [x, x]) || []}
          name="main_email_address"
          label="Principal email address"
          freeSolo
        />
        <RHFTextField
          name="main_phone_number"
          label="Principal phone number"
          fullWidth
        />
        <TagField
          name="tags_sectors"
          label="Sectors"
          tagTypeId="TAG_SECTOR"
          multiple
        />
        <TagField
          name="tags_business_models"
          label="Business model"
          tagTypeId="TAG_BUSINESS_MODEL"
          multiple
        />
        <RHFTextField
          name="description"
          label="Description"
          multiline
          fullWidth
          maxRows={20}
        />
      </Stack>
      <FormButtons />
    </>
  );
};

const PeopleForm = (props) => {
  return (
    <Form
      validationSchema={
        props.formType === "create"
          ? createValidationSchema
          : updateValidationSchema
      }
      prepareInitialValues={getInitialValues}
      {...props}
    >
      <PeopleFormFields />
    </Form>
  );
};

export const ModelPeopleForm = buildGenericModelForm({
  form: PeopleForm,
  useGet: usePeople,
  useCreate: useCreatePeople,
  useUpdate: useUpdatePeople,
  useDelete: useDeletePeople,
});
